import { render } from "./UserActivity.vue?vue&type=template&id=1bbf4be8&scoped=true&ts=true"
import script from "./UserActivity.vue?vue&type=script&lang=ts"
export * from "./UserActivity.vue?vue&type=script&lang=ts"

import "./UserActivity.vue?vue&type=style&index=0&id=1bbf4be8&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bbf4be8"]])

export default __exports__